import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import { QualitaMagazzinoModel } from 'Magazzino/Models/QualitaMagazzinoModel';
import { Input, List, message } from 'antd';

import Configurazione from '../../Configurazione';
import Footer from '../../Footer';
import { GetErrorMessage } from '../../Utility';
import api from '../../api';
import stringres from '../../translations/stringres';
import '../Magazzino.css';
import ElencoQualitaCard from './ElencoQualitaCard';
import HeaderBarMagazzino from './HeaderBarMagazzino';

export default function ElencoQualita() {
    const [data, setData] = useState<QualitaMagazzinoModel[]>([]);
    const [index, setIndex] = useState(0);
    const [descrizione, setDescrizione] = useState('');
    const [hasmore, setHasmore] = useState(true);
    const [forzaEsecuzione, setForzaEsecuzione] = useState(true);

    useEffect(() => {
        fetchElenco();
    }, [forzaEsecuzione]);

    async function fetchElenco() {
        try {
            const res = await api.get(
                'Magazzino/StockQualitaPage?idSocieta=' +
                    Configurazione().idsocieta +
                    '&descrizione=' +
                    descrizione +
                    '&index=' +
                    index +
                    '&rownumber=20'
            );

            const numerorighe = res.data.map((it) => it.length).length;

            if (numerorighe < 20) setHasmore(false);

            setIndex(index + numerorighe);

            setData([...data, ...res.data]);
        } catch (error) {
            message.error(GetErrorMessage(error));
        }
    }

    async function onSearch(e) {
        setData([]);

        setIndex(0);
        setHasmore(true);

        setForzaEsecuzione(!forzaEsecuzione);

        setDescrizione(e);
    }

    return (
        <div>
            <HeaderBarMagazzino menuSelezionato="" descrizione=""></HeaderBarMagazzino>
            <div style={{ padding: '40px', textAlign: 'center' }}>
                <Input.Search
                    onSearch={(e) => onSearch(e)}
                    enterButton
                    className="custom-search"
                    allowClear
                    style={{ width: '60%', height: '60px' }}
                    placeholder={stringres.t('ricercaqualita')}
                    size="large"
                />
            </div>
            <InfiniteScroll
                dataLength={data?.length}
                next={fetchElenco}
                hasMore={hasmore}
                scrollThreshold={0.8}
                loader={''}
            >
                <List
                    style={{ paddingLeft: '5%', paddingRight: '5%', alignSelf: 'center', textAlign: 'center' }}
                    dataSource={data}
                    grid={{ xs: 1, sm: 2, md: 3, lg: 4, xl: 5, xxl: 5 }}
                    renderItem={(item: QualitaMagazzinoModel) => {
                        return (
                            <div>
                                <ElencoQualitaCard
                                    idqualita={item.idQualita}
                                    qualita={item.descrizioneQualita}
                                    pezzi={item.pezzi}
                                    hasImage={item.hasImage}
                                    urlimmagine={item.urlimmagine}
                                ></ElencoQualitaCard>
                            </div>
                        );
                    }}
                ></List>
            </InfiniteScroll>
            <Footer></Footer>
        </div>
    );
}
